import { OrderableMenuItem } from './types';

export const ENABLED_LANGUAGES = ['ru', 'ru-by', 'ru-kz', 'ru-ua', 'kz', 'uk-ua'];

export const MENU_ITEMS: OrderableMenuItem[] = [
  {
    productKey: 'avia',
    desktopOrder: 1,
    mobileOrder: 1,
    allowedLanguages: ['ru', 'ru-by', 'ru-kz', 'ru-ua', 'kz', 'uk-ua'],
    default: true,
  },
  {
    productKey: 'hotels',
    desktopOrder: 2,
    mobileOrder: 2,
    allowedLanguages: ['ru', 'ru-kz', 'ru-ua', 'kz', 'uk-ua'],
    default: true,
  },
  {
    productKey: 'railways',
    desktopOrder: 3,
    mobileOrder: 3,
    allowedLanguages: ['ru', 'ru-kz', 'kz'],
    default: false,
  },
  // TODO 'tours', Временно HOT-7929
  {
    productKey: 'bus',
    desktopOrder: 4,
    mobileOrder: 4,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'activities',
    desktopOrder: 5,
    mobileOrder: 5,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'cars',
    desktopOrder: 6,
    mobileOrder: 6,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'explore',
    desktopOrder: 7,
    mobileOrder: 10,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'b2b',
    desktopOrder: 8,
    mobileOrder: 7,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'extranet',
    desktopOrder: 9,
    mobileOrder: 8,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'partners',
    desktopOrder: 10,
    mobileOrder: 9,
    allowedLanguages: ['ru'],
    default: false,
  },
  {
    productKey: 'loyalty',
    desktopOrder: 11,
    mobileOrder: 11,
    allowedLanguages: ['ru', 'ru-by', 'ru-kz', 'ru-ua', 'kz', 'uk-ua'],
    default: true,
  },
  {
    productKey: 'mobileApp',
    desktopOrder: 12,
    mobileOrder: 12,
    allowedLanguages: ['ru-by', 'ru-kz', 'ru-ua', 'kz', 'uk-ua'],
    default: true,
  },
  {
    productKey: 'hc',
    desktopOrder: 13,
    mobileOrder: 13,
    allowedLanguages: ['ru', 'ru-by', 'ru-kz', 'ru-ua', 'kz', 'uk-ua'],
    default: true,
  },
];
